import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_abkrtd2v7r: FaireBrandEntity = {
  token: "b_abkrtd2v7r",
  type: "brand",
  name: "Bathing Culture",
  avatarUrl:
    "https://cdn.faire.com/fastly/ff24061b70f8ed50ddd1c2a511569d5a67bc3086128fcf6d6899979519144be9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d29cfa56229d058ba5bb717fd4b2139b157a788c387de9e1e0044c3e16e6fc9d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ff24061b70f8ed50ddd1c2a511569d5a67bc3086128fcf6d6899979519144be9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d29cfa56229d058ba5bb717fd4b2139b157a788c387de9e1e0044c3e16e6fc9d.png",
  location: "San Francisco, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 30,
  isInsider: true,
  description:
    "Peace through bathing! Inspired by bathing among the redwood forests, volcanic hot springs, and plunging cliffs north of San Francisco, we started Bathing Culture to celebrate the simple necessity of bathing and how it can connect us to our planet. \n\nOur products are meticulously crafted to provide joyful, effective bathing experiences with the minimum impact on our warming Earth. We craft our California-inspired scents from 100% essential oils and we rigorously develop formulas from primarily organic plants, ensuring they’re biodegradable to protect our waterways. Our products are packaged in glass or post-consumer recycled plastic, and we run a nation-wide bulk refill program with over 200 partners to reduce packaging waste.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:15.653Z",
    importedBy: "entity-db-cli",
  },
};
